import React, { useState } from 'react';
import { pdf } from '@react-pdf/renderer';
import Button from 'components/0components/Button';

export default ({ document, fileName = 'export' }) => {

    const [loading, setLoading] = useState(false);

    // Génération au clic uniquement : évite qu'une erreur de rendu du document
    // ne fasse blanchir la page (PDFDownloadLink générait le doc dès le montage).
    const generate = async () => {
        setLoading(true);
        try {
            const blob = await pdf(document).toBlob();

            const url = URL.createObjectURL(blob);
            const a = window.document.createElement('a');
            a.href = url;
            a.download = `${fileName}.pdf`;
            a.click();
            URL.revokeObjectURL(url);
        } catch (e) {
            console.error('Échec génération PDF :', e);
            alert('Une erreur est survenue lors de la génération du PDF.');
        } finally {
            setLoading(false);
        }
    };

    return (<Button icon="fa-download" onClick={loading ? undefined : generate}>
        {loading ? 'Génération du document...' : 'Télécharger'}
    </Button>);
};
